// odsOperations.js
import { readSpreadsheet } from './spreadsheetReader';

export const readOdsFile = (file, progressCallback, columnMappings = {}) =>
  readSpreadsheet(file, {
    progressCallback,
    columnMappings,
    filterEmpty: true,
    maxHeaderScan: 10,
  });
